<template>
    <div class="w-full flex flex-col justify-start items-center" @mousewheel="wheelHandler($event)">
        <!-- <div class="w-full h-screen bg-red-100">
            1
        </div> -->
        <canvas id="imgCanvas" class="bg-gray-500">canvas</canvas>
        <!-- <div class="w-full h-screen bg-blue-100">
            2
        </div> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            locked: 0,
            firstFrame: 1,
            lastFrame: 119,
            currentIndex: 1,
            html: null,
            canvas: null,
            context: null,
            img: null,
        };
    },
    mounted() {
        this.html = document.documentElement
        this.canvas = document.getElementById("imgCanvas")
        this.context = this.canvas.getContext("2d")

        this.img = new Image()
        this.img.src = require("./../assets/animations/" + this.currentFrame(this.firstFrame));
        this.initialize()

        var self = this
        this.img.onload = function() {
            self.context.drawImage(self.img, 0, 0);
        };

        this.preloadImages()
    },
    methods: {
        currentFrame(index){
            return `${index.toString().padStart(4, "0")}.png`;
        },
        updateImage(index){
            this.img.src = require("./../assets/animations/" + this.currentFrame(index));
            this.context.drawImage(this.img, 0, 0);
        },
        preloadImages(){
            for (let i = 1; i < this.lastFrame; i++) {
                const img = new Image();
                img.src = require("./../assets/animations/" + this.currentFrame(i));
            }
        },
        initialize(){
            // Register an event listener to call the resizeCanvas() function
            // each time the window is resized.
            window.addEventListener("resize", this.resizeCanvas, false);
            // Draw canvas for the first time.
            this.resizeCanvas();
            this.updateImage(this.currentIndex)
        },
        resizeCanvas() {
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
        },
        wheelHandler(e) {
            var scrollRate = Math.ceil(Math.abs(e.deltaY) / 100)
            var direction = (e.deltaY > 0)

            if(direction && this.currentIndex == this.firstFrame && window.innerHeight >= this.canvas.getBoundingClientRect().bottom){
                this.locked = 1
            }
            if(!direction && this.currentIndex == this.lastFrame && this.canvas.getBoundingClientRect().top >= 0){
                this.locked = 1
            }

            if(this.locked){
                e.preventDefault()
                this.html.scrollTop = this.canvas.offsetTop + this.canvas.offsetHeight - window.innerHeight
                if(direction){
                    this.currentIndex = Math.min(this.lastFrame, this.currentIndex + scrollRate)
                } else {
                    this.currentIndex = Math.max(this.firstFrame, this.currentIndex - scrollRate)
                }
                this.updateImage(this.currentIndex)
                if (this.currentIndex == this.firstFrame || this.currentIndex == this.lastFrame){
                    this.locked = 0
                }
            }

            // if(scrollRate > 0){
            //     if (window.innerHeight >= this.canvas.getBoundingClientRect().bottom && this.currentIndex < this.frameCount) {
            //         console.log("animation")
            //         e.preventDefault()
            //         this.html.scrollTop = this.canvas.offsetTop + this.canvas.offsetHeight - window.innerHeight;
            //         this.currentIndex = Math.min(this.frameCount - 1, this.currentIndex + Math.ceil(Math.abs(e.deltaY) / 100))
            //         this.updateImage(this.currentIndex)
            //     }
            // }

            // else if(scrollRate < 0){
            //     console.log("up")
            //     if (window.innerHeight >= this.canvas.getBoundingClientRect().bottom) {
            //         console.log("animation up")
            //         e.preventDefault()
            //         this.html.scrollTop = this.canvas.offsetTop + this.canvas.offsetHeight - window.innerHeight;
            //         this.currentIndex = Math.max(this.startingFrame, this.currentIndex - Math.ceil(Math.abs(e.deltaY) / 100))
            //         this.updateImage(this.currentIndex)
            //     }
            // }

            // if (window.innerHeight >= this.canvas.getBoundingClientRect().bottom && this.currentIndex < this.frameCount) {
            //     e.preventDefault()
            //     this.html.scrollTop = this.canvas.offsetTop + this.canvas.offsetHeight - window.innerHeight;
            //     this.currentIndex = Math.min(this.frameCount - 1, this.currentIndex + Math.floor(e.deltaY / 100))
            //     this.updateImage(this.currentIndex)
            //     this.currentIndex += 1
            // }
            // if(window.innerHeight >= this.canvas.getBoundingClientRect().bottom && this.currentIndex < this.frameCount) {
            //     e.preventDefault()
            //     this.html.scrollTop = this.canvas.offsetTop + this.canvas.offsetHeight - window.innerHeight;
            //     this.currentIndex = Math.min(this.frameCount - 1, this.currentIndex + Math.floor(e.deltaY / 100))
            //     this.updateImage(this.currentIndex)
            //     this.currentIndex += 1
            // }
        },
    },
};
</script>
<style lang="postcss" scoped></style>
